export default __webpack_public_path__ + "static/media/162532851_108630724644783_8235078000908314034_n.5cd8cb88.jpg";